// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from 'translations/ja';

const lang = 'ja';

i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
  },
  lng: lang,
  fallbackLng: lang,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
